export const exploreImages = [
  {
    id: 'mbsMBZjq37pSRvcrJD5W',
    title:
      'woman, dark african woman, white hair, tall, slender, athletic build, defined shoulders, on her back, jeans pulled down, tight top, desperate expression, tears in eyes, wobbly smile, basement setting, ((vaginal penetration)), missionary start, guiding hips, hands on hips, clenched around him, first inch, real, emotional',
    fetchKey: null,
    imageUrl: 'assets/explore/mbsMBZjq37pSRvcrJD5W.mp4',
    description:
      'woman, dark african woman, white hair, tall, slender, athletic build, defined shoulders, on her back, jeans pulled down, tight top, desperate expression, tears in eyes, wobbly smile, basement setting, ((vaginal penetration)), missionary start, guiding hips, hands on hips, clenched around him, first inch, real, emotional',
    likes: 9,
    nsfw: false,
    date: '2026-09-02 14:52:38',
    uid: 'FQr60LOs4vbH9lliUNbynTDulbn2',
    model: 'Pony Photo XL 2',
    width: 704,
    height: 1280,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'POV Missionary',
    lorasList: [],
    views: 17,
    upscaled: false,
    seed: '2312812543',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/FQr60LOs4vbH9lliUNbynTDulbn2/preview_images/mbsMBZjq37pSRvcrJD5W.webp',
    videoVersion: 5,
    age_slider: 21,
    weight_slider: -0.05,
    breast_slider: 0.1,
    ass_slider: 0.25,
    penis_slider: null,
    loop: false,
    frame_rate: 48,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/FQr60LOs4vbH9lliUNbynTDulbn2/images/mbsMBZjq37pSRvcrJD5W.jpg',
    audio_enabled: true,
    video_version: 'video5',
    camera_move: null,
    dialogue:
      'FUCK YES, FILL THAT TIGHT PUSSY WITH YOUR WHITE DICK. I WANT IT, I NEED IT. Please use me and cum deep inside',
    dialogue_speaker: 'woman',
    dialogue_tone: 'seductive',
    dialogue_accent: 'american',
    video_length: 10,
    video_fps: 48,
    video_resolution: 'standard',
  },
  {
    id: '1H4QsUAKM1LsPYJojs2t',
    title:
      'sexy bride, blue eyes, slender, blonde hair up, erect nipples, (((nude))), ((cameltoe)), full body, wedding chapel',
    fetchKey: null,
    imageUrl: 'assets/explore/1H4QsUAKM1LsPYJojs2t.webp',
    description:
      'sexy bride, blue eyes, slender, blonde hair up, erect nipples, (((nude))), ((cameltoe)), full body, wedding chapel',
    likes: 25,
    nsfw: false,
    date: '2026-08-20 18:05:17',
    uid: 'uG8aoAxotweYeqUFCIOvgI6WjG52',
    model: 'Pony Photo XL 2',
    width: 909,
    height: 1280,
    creativity: 5,
    negativePrompt:
      'hat, ugly, wrinkles, (bunny ears), big nipples, cat ears, (penis), statue, (green skin), extra nipples, low resolution, ((extra limbs)), deformed hands, deformed feet, deformed face, distorted face, distortion, deformed vagina',
    loras: 'Custom',
    lorasList: [],
    views: 45,
    upscaled: false,
    seed: '2755671246',
    reports: 0,
    filter: 'Default',
    details: 2,
    expression: 'Default',
    aspect: null,
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 26,
    weight_slider: -0.2,
    breast_slider: 0.3,
    ass_slider: -0.05,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/uG8aoAxotweYeqUFCIOvgI6WjG52/images/1H4QsUAKM1LsPYJojs2t.jpg',
    audio_enabled: null,
  },
  {
    id: 'mVcs0nH6nBHwDeA3ycbH',
    title:
      'a sensual naked woman with full curves and long brown curls lies seductively on crushed white sheets, a hand slides over her thigh, warm candlelight and soft shadow, intimate and erotic mood, hyperrealistic act photography,tic lighting, sitting on mans lap, facing him in lotus sex position',
    fetchKey: null,
    imageUrl: 'assets/explore/mVcs0nH6nBHwDeA3ycbH.mp4',
    description:
      'a sensual naked woman with full curves and long brown curls lies seductively on crushed white sheets, a hand slides over her thigh, warm candlelight and soft shadow, intimate and erotic mood, hyperrealistic act photography,tic lighting, sitting on mans lap, facing him in lotus sex position',
    likes: 9,
    nsfw: false,
    date: '2026-08-31 06:20:01',
    uid: 'Ui2WvgPmaFYgjIfGIOGsMmDMAEg1',
    model: 'Cinematic Flame',
    width: 704,
    height: 388,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Girl Riding Guy',
    lorasList: [],
    views: 19,
    upscaled: false,
    seed: '583673510',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/Ui2WvgPmaFYgjIfGIOGsMmDMAEg1/preview_images/mVcs0nH6nBHwDeA3ycbH.webp',
    videoVersion: 5,
    age_slider: 24,
    weight_slider: 0,
    breast_slider: 0.1,
    ass_slider: 0,
    penis_slider: null,
    loop: false,
    frame_rate: 24,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/Ui2WvgPmaFYgjIfGIOGsMmDMAEg1/preview_images/mVcs0nH6nBHwDeA3ycbH.webp',
    audio_enabled: true,
    video_version: 'video5',
    camera_move: 'handheld',
    dialogue: "She doesn't deserve your cum. Give it to me.",
    dialogue_speaker: 'woman',
    dialogue_tone: 'seductive',
    dialogue_accent: 'american',
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: 'gegaEFN3Bz0XmYu169pt',
    title:
      'realistic photo of a closeup side view of a sexy and beautiful darkskinned supermodels face lying on her back with her eyes open and lips parted and tongue sticking out, lips and chin are shiny and wet and covered in drips of white cum streaming down her chin and coating her lips, an erect and wet penis hovers over her face with cum dripping from the tip onto womans tongue, cum on tongue, in bed on opulent bedroom eyes open looking at viewer massive blue eyes brown hair white dick',
    fetchKey: null,
    imageUrl: 'assets/explore/gegaEFN3Bz0XmYu169pt.webp',
    description:
      'realistic photo of a closeup side view of a sexy and beautiful darkskinned supermodels face lying on her back with her eyes open and lips parted and tongue sticking out, lips and chin are shiny and wet and covered in drips of white cum streaming down her chin and coating her lips, an erect and wet penis hovers over her face with cum dripping from the tip onto womans tongue, cum on tongue, in bed on opulent bedroom eyes open looking at viewer massive blue eyes brown hair white dick',
    likes: 10,
    nsfw: false,
    date: '2026-08-04 23:08:46',
    uid: 'd8gfcYVwUFWGWHV31r0uqrii6P02',
    model: 'Cinematic Flame',
    width: 985,
    height: 1280,
    creativity: 0.0,
    negativePrompt:
      'crooked teeth, brown eyes, uneven eyes, anime, tattoos, dark eyes, pale skin, piercings, dirty teeth,',
    loras: 'Default',
    lorasList: [],
    views: 35,
    upscaled: false,
    seed: '2900381934',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Default',
    aspect: 'Portrait',
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/d8gfcYVwUFWGWHV31r0uqrii6P02/images/gegaEFN3Bz0XmYu169pt.jpg',
    audio_enabled: null,
  },
  {
    id: 'hSPcsoM7N1CwfL5Ntwjq',
    title:
      'sexy, beautiful face, long platinum blonde hair, blue eyes, large heavy breasts, nipple bulge, white sweater, black jeans, suggestive pose, ((biting lower lip)), ((front view))',
    fetchKey: null,
    imageUrl: 'assets/explore/hSPcsoM7N1CwfL5Ntwjq.mp4',
    description:
      'sexy, beautiful face, long platinum blonde hair, blue eyes, large heavy breasts, nipple bulge, white sweater, black jeans, suggestive pose, ((biting lower lip)), ((front view))',
    likes: 15,
    nsfw: false,
    date: '2026-08-21 17:43:17',
    uid: 'pDjtaj4XFEP7UECBhyUymYRFln53',
    model: 'Pony XL 2',
    width: 704,
    height: 1220,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Default',
    lorasList: [],
    views: 22,
    upscaled: false,
    seed: '1647215184',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'High',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/pDjtaj4XFEP7UECBhyUymYRFln53/preview_images/hSPcsoM7N1CwfL5Ntwjq.webp',
    videoVersion: 4,
    age_slider: 21,
    weight_slider: -0.1,
    breast_slider: 0.2,
    ass_slider: 0.1,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/pDjtaj4XFEP7UECBhyUymYRFln53/preview_images/hSPcsoM7N1CwfL5Ntwjq.webp',
    audio_enabled: false,
    video_version: 'video4',
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: 'KlcUaB8LojY7k1vAbcKt',
    title:
      'random sex position, creampie, messy creampie, random size attributes, bouncing breasts, bouncing ass, large penis, thick thighs, prone bone, xray',
    fetchKey: null,
    imageUrl: 'assets/explore/KlcUaB8LojY7k1vAbcKt.webp',
    description:
      'random sex position, creampie, messy creampie, random size attributes, bouncing breasts, bouncing ass, large penis, thick thighs, prone bone, xray',
    likes: 7,
    nsfw: false,
    date: '2026-08-29 22:00:43',
    uid: 'inWGcnlNTpUpVRlXgIb4LK0NTBq2',
    model: 'Anime Flame',
    width: 1216,
    height: 832,
    creativity: 0.0,
    negativePrompt: 'Black penis',
    loras: 'Default',
    lorasList: [],
    views: 16,
    upscaled: false,
    seed: '3988520548',
    reports: 0,
    filter: 'Default',
    details: 2,
    expression: 'Default',
    aspect: 'Wide',
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 21,
    weight_slider: -0.05,
    breast_slider: 0.2,
    ass_slider: 0.3,
    penis_slider: 0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/inWGcnlNTpUpVRlXgIb4LK0NTBq2/images/KlcUaB8LojY7k1vAbcKt.jpg',
    audio_enabled: null,
  },
  {
    id: 'qWwqYReLAC2VNkgyJ3mr',
    title:
      'woman, ginger, long hair, large cleavage, nude, ((missionary)), legs around waist, vaginal penetration, sweaty, messy, intense expression, eyes rolled back, moaning, intimate, bedroom, dim lighting',
    fetchKey: null,
    imageUrl: 'assets/explore/qWwqYReLAC2VNkgyJ3mr.mp4',
    description:
      'woman, ginger, long hair, large cleavage, nude, ((missionary)), legs around waist, vaginal penetration, sweaty, messy, intense expression, eyes rolled back, moaning, intimate, bedroom, dim lighting',
    likes: 12,
    nsfw: false,
    date: '2026-09-02 07:19:55',
    uid: 'kjXufSGsFHcmilUepPPW10GLGQS2',
    model: 'Pony XL 2',
    width: 704,
    height: 1280,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'POV Missionary',
    lorasList: [],
    views: 11,
    upscaled: false,
    seed: '2801937385',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/kjXufSGsFHcmilUepPPW10GLGQS2/preview_images/qWwqYReLAC2VNkgyJ3mr.webp',
    videoVersion: 5,
    age_slider: 28,
    weight_slider: -0.05,
    breast_slider: 0.2,
    ass_slider: 0.0,
    penis_slider: null,
    loop: false,
    frame_rate: 24,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/kjXufSGsFHcmilUepPPW10GLGQS2/images/qWwqYReLAC2VNkgyJ3mr.jpg',
    audio_enabled: true,
    video_version: 'video5',
    camera_move: null,
    dialogue: 'Oh shit! Oh Fuck! Cum inside that married pussy baby! Oh fuck!',
    dialogue_speaker: 'woman',
    dialogue_tone: 'neutral',
    dialogue_accent: 'default',
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: 'JSrWJOKBEDNouBuZvoZj',
    title:
      'at party, people looking at them, college party, correct anatomy, pool party, wet group, nude female',
    fetchKey: null,
    imageUrl: 'assets/explore/JSrWJOKBEDNouBuZvoZj.webp',
    description:
      'at party, people looking at them, college party, correct anatomy, pool party, wet group, nude female',
    likes: 8,
    nsfw: false,
    date: '2026-08-07 13:14:46',
    uid: 'LpJwkCGafjafqXQy3T32tRdr5qc2',
    model: 'Pony Illustration XL',
    width: 924,
    height: 1280,
    creativity: 7,
    negativePrompt:
      'bad anatomy, bad hands, mutated hands, deformed hands, deformed fingers, mutated fingers, extra fingers, extra hands, extra legs',
    loras: 'Default',
    lorasList: [],
    views: 20,
    upscaled: false,
    seed: '3931279082',
    reports: 0,
    filter: 'Minimalist',
    details: '',
    expression: 'Default',
    aspect: null,
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/LpJwkCGafjafqXQy3T32tRdr5qc2/images/JSrWJOKBEDNouBuZvoZj.jpg',
    audio_enabled: null,
  },
  {
    id: 'wfAvYojwYg5PKlzQWGDZ',
    title:
      '((chinese)), ((anal dildo)), pornstar, wide hips, ((long nipples)),((large aureolas)), ((engorges nipples)), tattoos, garter belt, background stripclub, neon lights, front pov',
    fetchKey: null,
    imageUrl: 'assets/explore/wfAvYojwYg5PKlzQWGDZ.mp4',
    description:
      '((chinese)), ((anal dildo)), pornstar, wide hips, ((long nipples)),((large aureolas)), ((engorges nipples)), tattoos, garter belt, background stripclub, neon lights, front pov',
    likes: 9,
    nsfw: false,
    date: '2026-09-02 17:01:56',
    uid: 'ULLPwayiIiVhUYyKlqwiDKj9olF2',
    model: 'Pony Photo XL 2',
    width: 704,
    height: 1220,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Dildo',
    lorasList: [],
    views: 8,
    upscaled: false,
    seed: '818427807',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'High',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/ULLPwayiIiVhUYyKlqwiDKj9olF2/preview_images/wfAvYojwYg5PKlzQWGDZ.webp',
    videoVersion: 4,
    age_slider: 21,
    weight_slider: 0.1,
    breast_slider: 0.4,
    ass_slider: 0.3,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/ULLPwayiIiVhUYyKlqwiDKj9olF2/preview_images/wfAvYojwYg5PKlzQWGDZ.webp',
    audio_enabled: false,
    video_version: 'video4',
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: 'jK8BJEfTIY12BZ0pX17u',
    title:
      'bust image of a gorgeous african fashionmodel, very dark skin, (((very long false eyelashes))), sultry asian eyes, mascara, eyeshadow, heavy makeup, broad mouth, thick glossy lips, dark brown eyes',
    fetchKey: null,
    imageUrl: 'assets/explore/jK8BJEfTIY12BZ0pX17u.webp',
    description:
      'bust image of a gorgeous african fashionmodel, very dark skin, (((very long false eyelashes))), sultry asian eyes, mascara, eyeshadow, heavy makeup, broad mouth, thick glossy lips, dark brown eyes',
    likes: 7,
    nsfw: false,
    date: '2026-08-10 06:50:13',
    uid: 'mt2PeHxlyahgctWWHnvRqrnXg1m1',
    model: 'Pony Photo XL 2',
    width: 880,
    height: 1184,
    creativity: 1,
    negativePrompt: 'caucasian, runny mascara, wide angle, closeup',
    loras: 'Default',
    lorasList: [],
    views: 5,
    upscaled: false,
    seed: '58295206421388496',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Default',
    aspect: null,
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 27,
    weight_slider: 0.0,
    breast_slider: 0.0,
    ass_slider: 0.0,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/mt2PeHxlyahgctWWHnvRqrnXg1m1/images/jK8BJEfTIY12BZ0pX17u.jpg',
    audio_enabled: null,
  },
  {
    id: 'Aac6PiEAf3nNb59bN5yG',
    title:
      'a yo woman in an openplan office strawberryblonde hair tied in a long, slightly messy bun m tall fair skin, blue eyes, thin eyebrows, delicate lips, slender facial features, three beauty marks on her cheeks, which are very slightly rosy natural look, no makeup, effortlessly charmingmiddl bust slim figure with shapely, rounded buttocks discreet gold earrings lightweight beige cotton tank dress with red and green floral patterns black leather dr martens boots she walk alone on the street',
    fetchKey: null,
    imageUrl: 'assets/explore/Aac6PiEAf3nNb59bN5yG.mp4',
    description:
      'a yo woman in an openplan office strawberryblonde hair tied in a long, slightly messy bun m tall fair skin, blue eyes, thin eyebrows, delicate lips, slender facial features, three beauty marks on her cheeks, which are very slightly rosy natural look, no makeup, effortlessly charmingmiddl bust slim figure with shapely, rounded buttocks discreet gold earrings lightweight beige cotton tank dress with red and green floral patterns black leather dr martens boots she walk alone on the street',
    likes: 12,
    nsfw: false,
    date: '2026-08-12 07:20:20',
    uid: 'L5gIkhY5YBTOtvb2Px3lHbpnO5h2',
    model: 'Real',
    width: 480,
    height: 832,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'POV Anal',
    lorasList: [],
    views: 25,
    upscaled: false,
    seed: '3588297544',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/L5gIkhY5YBTOtvb2Px3lHbpnO5h2/preview_images/Aac6PiEAf3nNb59bN5yG.webp',
    videoVersion: 4,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/L5gIkhY5YBTOtvb2Px3lHbpnO5h2/images/Aac6PiEAf3nNb59bN5yG.jpg',
    audio_enabled: false,
    video_version: null,
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: null,
    video_fps: null,
    video_resolution: null,
  },
  {
    id: 'BY4FlDvEy8qztVcGHh7L',
    title:
      'long uneven parted ginger hair, long lashes, perky tits, busty, hourglass body, freckles, blue eyes, white skirt, purple crop top, choker , in a train',
    fetchKey: null,
    imageUrl: 'assets/explore/BY4FlDvEy8qztVcGHh7L.webp',
    description:
      'long uneven parted ginger hair, long lashes, perky tits, busty, hourglass body, freckles, blue eyes, white skirt, purple crop top, choker , in a train',
    likes: 13,
    nsfw: false,
    date: '2026-08-16 18:59:20',
    uid: '5fuKhh2z1PdrjoD1lx1riOQGV9p2',
    model: 'Pony Illustration XL',
    width: 1280,
    height: 924,
    creativity: 7,
    negativePrompt: '',
    loras: 'Flashing Boobs',
    lorasList: [],
    views: 17,
    upscaled: false,
    seed: '1295175838',
    reports: 0,
    filter: 'Cinematic',
    details: '',
    expression: 'Default',
    aspect: null,
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/5fuKhh2z1PdrjoD1lx1riOQGV9p2/images/BY4FlDvEy8qztVcGHh7L.jpg',
    audio_enabled: null,
  },
  {
    id: '7YArgV3gQTC6ImSOVQbp',
    title:
      'thai woman, naked just after a shower, wearing black bra, perfect ass, hourglass figure, side shot, taking photo, showing off her ass, thick thighs, standing doggy style sex, vigorous fucking, fast fucking, loud moaning, intense visceral moaning, orgasm, vaginal sex, ((hypermassive cock)), ((huge cock)), ((long cock))',
    fetchKey: null,
    imageUrl: 'assets/explore/7YArgV3gQTC6ImSOVQbp.mp4',
    description:
      'thai woman, naked just after a shower, wearing black bra, perfect ass, hourglass figure, side shot, taking photo, showing off her ass, thick thighs, standing doggy style sex, vigorous fucking, fast fucking, loud moaning, intense visceral moaning, orgasm, vaginal sex, ((hypermassive cock)), ((huge cock)), ((long cock))',
    likes: 10,
    nsfw: false,
    date: '2026-09-01 11:39:41',
    uid: 'mZMt4wUGv8YeEZe7tRJn3g5BzGy2',
    model: 'Pony Photo XL 2',
    width: 704,
    height: 406,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'POV Anal',
    lorasList: [],
    views: 20,
    upscaled: false,
    seed: '1384376549',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/mZMt4wUGv8YeEZe7tRJn3g5BzGy2/preview_images/7YArgV3gQTC6ImSOVQbp.webp',
    videoVersion: 5,
    age_slider: 28,
    weight_slider: 0,
    breast_slider: 0,
    ass_slider: 0,
    penis_slider: null,
    loop: false,
    frame_rate: 48,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/mZMt4wUGv8YeEZe7tRJn3g5BzGy2/images/7YArgV3gQTC6ImSOVQbp.jpg',
    audio_enabled: true,
    video_version: 'video5',
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: 10,
    video_fps: 48,
    video_resolution: 'high',
  },
  {
    id: 'ltbBOSGWzayDHyY3UJgc',
    title:
      'sexy girl, skinny girl, hooters, glowing eyes, tear drop tits, fit body, tits out, big natural tits, thong, perfect tits',
    fetchKey: null,
    imageUrl: 'assets/explore/ltbBOSGWzayDHyY3UJgc.webp',
    description:
      'sexy girl, skinny girl, hooters, glowing eyes, tear drop tits, fit body, tits out, big natural tits, thong, perfect tits',
    likes: 19,
    nsfw: false,
    date: '2026-08-17 03:41:22',
    uid: '7H99Gjgf1EOA9NKkxZrDqxVs2u73',
    model: 'Cinematic Flame',
    width: 985,
    height: 1280,
    creativity: 0.0,
    negativePrompt: 'tanlines',
    loras: 'Default',
    lorasList: [],
    views: 48,
    upscaled: false,
    seed: '452506146',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Default',
    aspect: 'Portrait',
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 24,
    weight_slider: -0.15,
    breast_slider: 0.05,
    ass_slider: 0,
    penis_slider: 0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/7H99Gjgf1EOA9NKkxZrDqxVs2u73/images/ltbBOSGWzayDHyY3UJgc.jpg',
    audio_enabled: null,
  },
  {
    id: '0qbUH20CxzjuAuvC4YeX',
    title:
      'gorgeous nigerian woman,(((dark skinned woman))),beautiful makeup,home, living room, slutty clothing,wanton lust,looking up at man,sucking the cock of a tall man (((muscular white man))) hypermassive cock, ,(((((((((hypermassive thick cock))))))))), his huge hands holding her head,tons of saliva oozing from her chin',
    fetchKey: null,
    imageUrl: 'assets/explore/0qbUH20CxzjuAuvC4YeX.mp4',
    description:
      'gorgeous nigerian woman,(((dark skinned woman))),beautiful makeup,home, living room, slutty clothing,wanton lust,looking up at man,sucking the cock of a tall man (((muscular white man))) hypermassive cock, ,(((((((((hypermassive thick cock))))))))), his huge hands holding her head,tons of saliva oozing from her chin',
    likes: 6,
    nsfw: false,
    date: '2026-08-31 05:45:39',
    uid: 'dmpqUOtwwAce5aK9VtqjgpiZ3qp1',
    model: 'Pony XL',
    width: 704,
    height: 406,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'POV Threesome BlowJob',
    lorasList: [],
    views: 11,
    upscaled: false,
    seed: '457640280',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/dmpqUOtwwAce5aK9VtqjgpiZ3qp1/preview_images/0qbUH20CxzjuAuvC4YeX.webp',
    videoVersion: 4,
    age_slider: 21,
    weight_slider: 0.0,
    breast_slider: 0.0,
    ass_slider: 0.4,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/dmpqUOtwwAce5aK9VtqjgpiZ3qp1/images/0qbUH20CxzjuAuvC4YeX.jpg',
    audio_enabled: true,
    video_version: 'video4',
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: 'yV5nXJi3WAz96h71HH65',
    title:
      '((korean)), pale skin, (big brown eyes), (black eyeliner), massive breasts, long hair',
    fetchKey: null,
    imageUrl: 'assets/explore/yV5nXJi3WAz96h71HH65.webp',
    description:
      '((korean)), pale skin, (big brown eyes), (black eyeliner), massive breasts, long hair',
    likes: 11,
    nsfw: false,
    date: '2026-08-13 06:53:07',
    uid: 'mZZPKNHw8qdhCmevoSqxBRaStJm1',
    model: 'Pony XL 2',
    width: 880,
    height: 1184,
    creativity: 1,
    negativePrompt:
      '(lipstick), (thick eyebrows), curly or wavy hair, (big nipples), athletic, tan lines, dark skin, (tattoos), wet or shiny skin',
    loras: 'Front Camera Selfie',
    lorasList: [],
    views: 16,
    upscaled: false,
    seed: '8232570360461392285',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Default',
    aspect: null,
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/mZZPKNHw8qdhCmevoSqxBRaStJm1/images/yV5nXJi3WAz96h71HH65.jpg',
    audio_enabled: null,
  },
  {
    id: '0IGMMgXBlrazmKcgW3qa',
    title:
      'woman, ginger, long straight hair, (cum inside), vaginal penetration, missionary position, collapsed on bed, trembling, heavylidded eyes, exhausted, sweaty, nude, ((just finished orgasm)), messy sheets, dim lighting, surrender, shaky hand on thigh',
    fetchKey: null,
    imageUrl: 'assets/explore/0IGMMgXBlrazmKcgW3qa.mp4',
    description:
      'woman, ginger, long straight hair, (cum inside), vaginal penetration, missionary position, collapsed on bed, trembling, heavylidded eyes, exhausted, sweaty, nude, ((just finished orgasm)), messy sheets, dim lighting, surrender, shaky hand on thigh',
    likes: 16,
    nsfw: false,
    date: '2026-08-31 17:34:32',
    uid: 'zNbKKFDPE4R4P0bdFilvzudjr5h1',
    model: 'Pony XL 2',
    width: 704,
    height: 1280,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'POV Missionary',
    lorasList: [],
    views: 15,
    upscaled: false,
    seed: '3558997646',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/zNbKKFDPE4R4P0bdFilvzudjr5h1/preview_images/0IGMMgXBlrazmKcgW3qa.webp',
    videoVersion: 5,
    age_slider: 28,
    weight_slider: -0.05,
    breast_slider: 0.2,
    ass_slider: 0.0,
    penis_slider: null,
    loop: false,
    frame_rate: 24,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/zNbKKFDPE4R4P0bdFilvzudjr5h1/images/0IGMMgXBlrazmKcgW3qa.jpg',
    audio_enabled: true,
    video_version: 'video5',
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: null,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: '9azriL1kVBufwHD1zDOZ',
    title:
      '((vaportwave neon)) naked woman ((foot )), loba, [[liara]], ((white hair behind ears)), buns, [long hair] latina, naked female [face shoulders elbow areolae glam], subtle blush cheeks thin choker, silver earring, thick thighs, large natural breast glossy skin, ((parted lips))',
    fetchKey: null,
    imageUrl: 'assets/explore/9azriL1kVBufwHD1zDOZ.webp',
    description:
      '((vaportwave neon)) naked woman ((foot )), loba, [[liara]], ((white hair behind ears)), buns, [long hair] latina, naked female [face shoulders elbow areolae glam], subtle blush cheeks thin choker, silver earring, thick thighs, large natural breast glossy skin, ((parted lips))',
    likes: 7,
    nsfw: false,
    date: '2026-08-11 16:45:33',
    uid: 'LpJwkCGafjafqXQy3T32tRdr5qc2',
    model: 'Pony Illustration XL',
    width: 880,
    height: 1184,
    creativity: 1,
    negativePrompt:
      'rough sketch, ((anime)), comic strip, cartoonish, manga, bad anatomy, bald (alien head), [purple hair] clothed, underwear milf, elder gaping, spreading bad fingers, futanari, chick with dick, trans, sad',
    loras: 'Anime Boob Bounce',
    lorasList: [],
    views: 14,
    upscaled: false,
    seed: '8656022013762138685',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Default',
    aspect: null,
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/LpJwkCGafjafqXQy3T32tRdr5qc2/images/9azriL1kVBufwHD1zDOZ.jpg',
    audio_enabled: null,
  },
  {
    id: 'oABjwH41M0vLiBNFNF19',
    title:
      'redhead, full body, sexy green panties, bedroom, camel toe, fay pussy lips, shirt above breast',
    fetchKey: null,
    imageUrl: 'assets/explore/oABjwH41M0vLiBNFNF19.mp4',
    description:
      'redhead, full body, sexy green panties, bedroom, camel toe, fay pussy lips, shirt above breast',
    likes: 12,
    nsfw: false,
    date: '2026-08-05 08:39:00',
    uid: 'FfPbgujGwIdYKYpZG8Bhb7G0FlS2',
    model: 'Real',
    width: 480,
    height: 832,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Default',
    lorasList: [],
    views: 23,
    upscaled: false,
    seed: '3643709849',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/FfPbgujGwIdYKYpZG8Bhb7G0FlS2/preview_images/oABjwH41M0vLiBNFNF19.webp',
    videoVersion: 4,
    age_slider: 28,
    weight_slider: 0.05,
    breast_slider: 0.1,
    ass_slider: 0,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/FfPbgujGwIdYKYpZG8Bhb7G0FlS2/images/oABjwH41M0vLiBNFNF19.jpg',
    audio_enabled: false,
    video_version: null,
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: null,
    video_fps: null,
    video_resolution: null,
  },
  {
    id: 'XxXbhzKkigNZSrOq0JJa',
    title:
      'bimbo slut, ((giant cock anal fucking)), piercings, skirt pulled up, panties pulled down, dripping, star gazing, pink hair, bangs, pink make up, asian, very hot, black latex lingerie, tits out, laces, sexy, pink and black colors, pulling hair',
    fetchKey: null,
    imageUrl: 'assets/explore/XxXbhzKkigNZSrOq0JJa.webp',
    description:
      'bimbo slut, ((giant cock anal fucking)), piercings, skirt pulled up, panties pulled down, dripping, star gazing, pink hair, bangs, pink make up, asian, very hot, black latex lingerie, tits out, laces, sexy, pink and black colors, pulling hair',
    likes: 21,
    nsfw: false,
    date: '2026-08-12 22:03:29',
    uid: 'wNcw4dT3A4aSYwJJiI7vFmj6hwa2',
    model: 'Pony Anime XL',
    width: 1248,
    height: 1248,
    creativity: 7,
    negativePrompt: '',
    loras: 'Default',
    lorasList: [],
    views: 39,
    upscaled: false,
    seed: '1680544572',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Stick out Tongue',
    aspect: null,
    video: false,
    quality: 'Max',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 29,
    weight_slider: 0.0,
    breast_slider: 0.0,
    ass_slider: 0.0,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/wNcw4dT3A4aSYwJJiI7vFmj6hwa2/images/XxXbhzKkigNZSrOq0JJa.jpg',
    audio_enabled: null,
  },
  {
    id: 'A92ZJGGBfkqtDYgROflv',
    title: 'creampie, beautiful model, black lingerie, sex, messy creampie',
    fetchKey: null,
    imageUrl: 'assets/explore/A92ZJGGBfkqtDYgROflv.mp4',
    description:
      'creampie, beautiful model, black lingerie, sex, messy creampie',
    likes: 8,
    nsfw: false,
    date: '2026-09-02 18:54:33',
    uid: 'inWGcnlNTpUpVRlXgIb4LK0NTBq2',
    model: 'Pony Anime XL',
    width: 480,
    height: 832,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Default',
    lorasList: [],
    views: 0,
    upscaled: false,
    seed: '263522598',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/inWGcnlNTpUpVRlXgIb4LK0NTBq2/preview_images/A92ZJGGBfkqtDYgROflv.webp',
    videoVersion: 4,
    age_slider: 21,
    weight_slider: 0.0,
    breast_slider: 0.2,
    ass_slider: 0.0,
    penis_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/inWGcnlNTpUpVRlXgIb4LK0NTBq2/images/A92ZJGGBfkqtDYgROflv.jpg',
    audio_enabled: false,
    video_version: 'video4',
    camera_move: null,
    dialogue: null,
    dialogue_speaker: null,
    dialogue_tone: null,
    dialogue_accent: null,
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
  {
    id: 'Kla5OBhFLw2FWmtNDUWf',
    title:
      'latina, freckles, tan, messy black hair with(platinum highlights), blue eyes, , (thigh tattoos) eye contact , body fishnet, no panties, smooth pussy, no makeup, covered in copius amounts of and wet with sweatblowjob,cum in face',
    fetchKey: null,
    imageUrl: 'assets/explore/Kla5OBhFLw2FWmtNDUWf.webp',
    description:
      'latina, freckles, tan, messy black hair with(platinum highlights), blue eyes, , (thigh tattoos) eye contact , body fishnet, no panties, smooth pussy, no makeup, covered in copius amounts of and wet with sweatblowjob,cum in face',
    likes: 6,
    nsfw: false,
    date: '2026-08-23 08:09:20',
    uid: 'mlVaYwU1mvfoYupWg5EHaXnVPeH3',
    model: 'Cinematic Flame',
    width: 985,
    height: 1280,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Default',
    lorasList: [],
    views: 6,
    upscaled: false,
    seed: '3842424705',
    reports: 0,
    filter: 'Default',
    details: '',
    expression: 'Default',
    aspect: 'Portrait',
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 21,
    weight_slider: 0,
    breast_slider: 0,
    ass_slider: 0,
    penis_slider: 0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/mlVaYwU1mvfoYupWg5EHaXnVPeH3/images/Kla5OBhFLw2FWmtNDUWf.jpg',
    audio_enabled: null,
  },
  {
    id: 'u1t9rUFbY2bJxTWOclyN',
    title: 'tan asian woman, naked',
    fetchKey: null,
    imageUrl: 'assets/explore/u1t9rUFbY2bJxTWOclyN.mp4',
    description: 'tan asian woman, naked',
    likes: 9,
    nsfw: false,
    date: '2026-08-31 08:25:28',
    uid: 'JwJYIXqynFWCufSHWusPOganBHW2',
    model: 'Cinematic Flame',
    width: 704,
    height: 1280,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Girl Riding Guy',
    lorasList: [],
    views: 18,
    upscaled: false,
    seed: '1429996602',
    reports: 0,
    filter: '',
    details: '',
    expression: '',
    aspect: null,
    video: true,
    quality: 'Standard',
    videoThumbnail:
      'https://storage.promptdrive.net/generated_media/JwJYIXqynFWCufSHWusPOganBHW2/preview_images/u1t9rUFbY2bJxTWOclyN.webp',
    videoVersion: 5,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    penis_slider: null,
    loop: false,
    frame_rate: 24,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/JwJYIXqynFWCufSHWusPOganBHW2/images/u1t9rUFbY2bJxTWOclyN.jpg',
    audio_enabled: true,
    video_version: 'video5',
    camera_move: null,
    dialogue: "it's bigger! uhhh uhhh! it's bigger!",
    dialogue_speaker: 'woman',
    dialogue_tone: 'whisper',
    dialogue_accent: 'default',
    video_length: 6,
    video_fps: 24,
    video_resolution: 'standard',
  },
]

export const exploreImagesSafe = [
  {
    id: 'bowLqYGOk4mgXhMqIESi',
    title:
      'blonde, sexy, opened shirt, blue eyes, office, room with big windows, full room view, work outfit,',
    fetchKey: null,
    imageUrl: 'assets/exploreSafe/bowLqYGOk4mgXhMqIESi.webp',
    description:
      'blonde, sexy, opened shirt, blue eyes, office, room with big windows, full room view, work outfit,',
    likes: 1,
    nsfw: false,
    date: '2026-05-18 15:07:33',
    uid: 'nbttoqeoS5fEfHSZs0hIj8q2e8o2',
    model: 'Cinematic Flame',
    width: 0,
    height: 0,
    creativity: 0.0,
    negativePrompt: '',
    loras: 'Default',
    views: 5,
    upscaled: false,
    seed: '276312116',
    reports: 0,
    filter: 'DLSR',
    prompt_ja: '',
    prompt_de: '',
    prompt_zh: '',
    prompt_es: '',
    negative_prompt_ja: '',
    negative_prompt_de: '',
    negative_prompt_zh: '',
    negative_prompt_es: '',
    details: 0,
    expression: 'Smiling',
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 29,
    weight_slider: 0,
    breast_slider: 0,
    ass_slider: 0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/nbttoqeoS5fEfHSZs0hIj8q2e8o2/images/bowLqYGOk4mgXhMqIESi.jpg',
  },
  {
    id: 'AbxPIw5lBPvuD4LCJU7X',
    title:
      'beautiful curvy woman, purple skin color, purple skin, pointy ears, medium sized breasts, pubic hair, long white hair, long hair, castle bedroom, smirk, red eye color, ornate robes, moan, alone, moan, from below,',
    fetchKey: null,
    imageUrl: 'assets/exploreSafe/AbxPIw5lBPvuD4LCJU7X.webp',
    description:
      'beautiful curvy woman, purple skin color, purple skin, pointy ears, medium sized breasts, pubic hair, long white hair, long hair, castle bedroom, smirk, red eye color, ornate robes, moan, alone, moan, from below,',
    likes: 1,
    nsfw: false,
    date: '2026-05-20 15:39:50',
    uid: 'qdXKl6hYRsc9juTsAtPeE78gnFd2',
    model: 'Pony Illustration XL',
    width: 832,
    height: 1152,
    creativity: 7,
    negativePrompt: '',
    loras: 'Anime Boob Bounce',
    views: 5,
    upscaled: false,
    seed: 2079874275,
    reports: 0,
    filter: 'Oil Painting',
    prompt_ja: '',
    prompt_de: '',
    prompt_zh: '',
    prompt_es: '',
    negative_prompt_ja: '',
    negative_prompt_de: '',
    negative_prompt_zh: '',
    negative_prompt_es: '',
    details: 0,
    expression: 'Smiling',
    video: false,
    quality: 'Max',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 25,
    weight_slider: 0.0,
    breast_slider: 0.0,
    ass_slider: 0.0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/qdXKl6hYRsc9juTsAtPeE78gnFd2/images/AbxPIw5lBPvuD4LCJU7X.jpg',
  },
  {
    id: 'xWttfgncKwFy0MWOIX3n',
    title: 'cheerleader, black hair, changing room',
    fetchKey: null,
    imageUrl: 'assets/exploreSafe/xWttfgncKwFy0MWOIX3n.webp',
    description: 'cheerleader, black hair, changing room',
    likes: 1,
    nsfw: false,
    date: '2026-05-20 05:23:03',
    uid: 'inWGcnlNTpUpVRlXgIb4LK0NTBq2',
    model: 'Pony Anime XL',
    width: 832,
    height: 1152,
    creativity: 7,
    negativePrompt: '',
    loras: 'Default',
    views: 6,
    upscaled: false,
    seed: 3689105323,
    reports: 0,
    filter: 'Default',
    prompt_ja: '',
    prompt_de: '',
    prompt_zh: '',
    prompt_es: '',
    negative_prompt_ja: '',
    negative_prompt_de: '',
    negative_prompt_zh: '',
    negative_prompt_es: '',
    details: 0,
    expression: 'Default',
    video: false,
    quality: 'Ultra',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 21,
    weight_slider: 0.0,
    breast_slider: 0.3,
    ass_slider: 0.0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/inWGcnlNTpUpVRlXgIb4LK0NTBq2/images/xWttfgncKwFy0MWOIX3n.jpg',
  },
  {
    id: 'kryQBWx0xmeMp5pUpfM5',
    title:
      'most beautiful face, thick soft pink lips, busty, big breasts, long eyelashes, black eyeliner, platinum blonde hair, (big pale blue eyes), cleav, dark fantasy outfit',
    fetchKey: null,
    imageUrl: 'assets/exploreSafe/kryQBWx0xmeMp5pUpfM5.webp',
    description:
      'most beautiful face, thick soft pink lips, busty, big breasts, long eyelashes, black eyeliner, platinum blonde hair, (big pale blue eyes), cleav, dark fantasy outfit',
    likes: 2,
    nsfw: false,
    date: '2026-05-20 13:10:33',
    uid: 'mZZPKNHw8qdhCmevoSqxBRaStJm1',
    model: 'Pony XL 2',
    width: 912,
    height: 1280,
    creativity: 5,
    negativePrompt:
      '((lipstick)), (topless), naked, (thick eyebrows), (eyebags), (tattoos), (athletic), tan lines, hands on breasts, wet or shiny skin',
    loras: 'Front Camera Selfie',
    views: 17,
    upscaled: false,
    seed: 3826145955,
    reports: 0,
    filter: 'Default',
    prompt_ja: '',
    prompt_de: '',
    prompt_zh: '',
    prompt_es: '',
    negative_prompt_ja: '',
    negative_prompt_de: '',
    negative_prompt_zh: '',
    negative_prompt_es: '',
    details: 0,
    expression: 'Default',
    video: false,
    quality: 'Extreme',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: null,
    weight_slider: null,
    breast_slider: null,
    ass_slider: null,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/mZZPKNHw8qdhCmevoSqxBRaStJm1/images/kryQBWx0xmeMp5pUpfM5.jpg',
  },
  {
    id: 'YHHiCo2CD7MwklpVwdA7',
    title: 'lingerie ((((model from colombia, from bogota))))',
    fetchKey: null,
    imageUrl: 'assets/exploreSafe/YHHiCo2CD7MwklpVwdA7.webp',
    description: 'lingerie ((((model from colombia, from bogota))))',
    likes: 1,
    nsfw: false,
    date: '2026-05-20 18:16:48',
    uid: 'qhcNhDl1MOSx9wllFi2tMdWnGfz1',
    model: 'Pony XL 2',
    width: 912,
    height: 1280,
    creativity: 5,
    negativePrompt:
      'tiling, poorly drawn hands, poorly drawn feet, poorly drawn face, out of frame, extra limbs, disfigured, deformed, body out of frame, bad anatomy, cut off, weird teeth, distorted face, blurry, draft, grainy, out of focus, extra arms, extra belly button, water, text, font, flag, man, male, brand, blur, lowres',
    loras: 'Default',
    views: 28,
    upscaled: false,
    seed: 2186179035,
    reports: 0,
    filter: 'Default',
    prompt_ja: '',
    prompt_de: '',
    prompt_zh: '',
    prompt_es: '',
    negative_prompt_ja: '',
    negative_prompt_de: '',
    negative_prompt_zh: '',
    negative_prompt_es: '',
    details: 2,
    expression: 'Default',
    video: false,
    quality: 'Max',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 29,
    weight_slider: -0.1,
    breast_slider: 0.35,
    ass_slider: 0.0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/qhcNhDl1MOSx9wllFi2tMdWnGfz1/images/YHHiCo2CD7MwklpVwdA7.jpg',
  },
  {
    id: 'CRXhs8lqW6OX0cVNHn7K',
    title: 'emo girl, teased hair, black hair dyed blonde',
    fetchKey: null,
    imageUrl: 'assets/exploreSafe/CRXhs8lqW6OX0cVNHn7K.webp',
    description: 'emo girl, teased hair, black hair dyed blonde',
    likes: 1,
    nsfw: false,
    date: '2026-05-17 20:37:59',
    uid: 'MHO1Mb50u6ZIB0UDXr1cUHcsYeW2',
    model: 'Pony Anime XL',
    width: 832,
    height: 1152,
    creativity: 7,
    negativePrompt:
      'muscular, muscles, buff, furry, catgirl, muscles, cat ears, tan lines, badly drawn hands, beach setting, school setting, people in background',
    loras: 'Default',
    views: 5,
    upscaled: false,
    seed: 2060930209,
    reports: 0,
    filter: 'Default',
    prompt_ja: '',
    prompt_de: '',
    prompt_zh: '',
    prompt_es: '',
    negative_prompt_ja: '',
    negative_prompt_de: '',
    negative_prompt_zh: '',
    negative_prompt_es: '',
    details: 0,
    expression: 'Default',
    video: false,
    quality: 'Ultra',
    videoThumbnail: '',
    videoVersion: 1,
    age_slider: 21,
    weight_slider: 0.0,
    breast_slider: 0.0,
    ass_slider: 0.0,
    loop: false,
    frame_rate: 25,
    original_image_url:
      'https://storage.promptdrive.net/generated_media/MHO1Mb50u6ZIB0UDXr1cUHcsYeW2/images/CRXhs8lqW6OX0cVNHn7K.jpg',
  },
]
